import { logWarn } from './logging';

export const destType = {
    None: 0,
    Estab: 1,
    Location: 2,
    Province: 3,
    Country: 4,
    Place: 5,
    Polygon: 10
};

export function getObjectTypeAndId(d) {
    if (d.Type && d.Id) {
        return {
            Type: d.Type,
            Id: d.Id
        };
    }

    const type = get(d);
    return {
        Type: type,
        Id: getId(type, d)
    };
}

function getId(type, d) {
    if (d.ObjectId != null) {
        return d.ObjectId;
    }
    switch (type) {
        case destType.None: return null;
        case destType.Estab: return d.EstablishmentId || d.Id;
        case destType.Location: return d.LocationId;
        case destType.Province: return d.ProvinceId;
        case destType.Country: return d.CountryId;
        case destType.Place: return d.PlaceId;
        case destType.Polygon: return d.PolygonId;
    }
}

export function get(d) {
    if (d.Type) {
        return d.Type;
    }
    if (d.ObjectTypeId != null) {
        return d.ObjectTypeId;
    }
    if (d.EstablishmentId) {
        return destType.Estab;
    }
    if (d.PlaceId) {
        return destType.Place;
    }
    if (d.LocationId) {
        return destType.Location;
    }
    if (d.ProvinceId) {
        return destType.Province;
    }
    if (d.PolygonId) {
        return destType.Polygon;
    }
    if (d.CountryId) {
        return destType.Country;
    }
    logWarn(`Cannot determine object type from destination object: ${JSON.stringify(d)}`);
    return destType.None;
}

export function populateObjectTypeAndId(d) {
    if (d) {
        const typeAndId = getObjectTypeAndId(d);
        d.Type = typeAndId.Type;
        d.Id = typeAndId.Id;
    }
}
